"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxEditDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const mui_inputs_image_firebase_1 = require("@dzambalaorg/mui-inputs-image-firebase");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const validation_1 = require("./validation");
const types_2 = require("../../../../../../types");
const inputs_1 = require("../../../../../../inputs");
const schemas_1 = require("./schemas");
const MysteryBoxEditDialog = (props) => {
    const { selectedItem, open, mode, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, description, content, imageUrl, mysteryBoxStatus, template, 
    // @ts-ignore
    // this is only filter for contract autocomplete
    merchantId, } = selectedItem;
    const fixedValues = {
        id,
        title,
        description,
        content,
        imageUrl,
        mysteryBoxStatus,
        template,
        merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "MysteryBoxEditForm", filter: ({ id, template, title, description, imageUrl, content, mysteryBoxStatus }) => id
            ? {
                title,
                description,
                imageUrl,
                content: (0, exchange_1.cleanUpAsset)(content),
                price: (0, exchange_1.cleanUpAsset)(template?.price),
                mysteryBoxStatus,
            }
            : {
                contractId: template?.contractId,
                title,
                description,
                imageUrl,
                content: (0, exchange_1.cleanUpAsset)(content),
                price: (0, exchange_1.cleanUpAsset)(template?.price),
            }, ...rest, children: [service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "merchantId", controller: "merchants" }), (0, jsx_runtime_1.jsx)(inputs_1.ContractMerchantInput, { required: true, name: schemas_1.contractInputName[service], data: schemas_1.contractInputFetchData[service], readOnly: mode === "edit" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description", slotProps: { inputLabel: { required: true } } }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { required: true, autoSelect: true, multiple: true, prefix: "content", tokenType: { disabledOptions: [types_1.TokenType.NATIVE, types_1.TokenType.ERC20, types_1.TokenType.ERC1155] }, contract: {
                    data: {
                        contractModule: [types_1.ModuleType.HIERARCHY],
                        contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
                        contractFeatures: [types_1.ContractFeatures.RANDOM],
                    },
                }, forceAmount: true, readOnly: mode === "edit" }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { required: true, autoSelect: true, multiple: true, prefix: "template.price", tokenType: { disabledOptions: [types_1.TokenType.ERC721, types_1.TokenType.ERC998] }, contract: {
                    data: {
                        contractModule: [types_1.ModuleType.HIERARCHY],
                        contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
                    },
                } }), mode === "edit" && (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "mysteryBoxStatus", options: types_1.MysteryBoxStatus }), (0, jsx_runtime_1.jsx)(mui_inputs_image_firebase_1.AvatarInput, { name: "imageUrl", required: true })] }));
};
exports.MysteryBoxEditDialog = MysteryBoxEditDialog;
//# sourceMappingURL=index.js.map